import { Buffer } from "buffer";
import {
  createBrowserRouter,
  Outlet,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";
import SageChat from "./components/SageChat";
import UserList from "./components/UserList";
import RayCastWaves from "./components/Visualizations/RayCastWaves";
import NavbarMenu from "./NavbarMenu";
import About from "./website/About";
import Tos from "./website/Tos";
import AllMembers from "./website/AllMembers";
import ArtistHome from "./website/ArtistHome";
import ContactUs from "./website/ContactUs";
import Footer from "./website/Footer";

window.Buffer = Buffer;

// 1️⃣ Changed from App to Root
function Groot() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/*  <Route path="/live-streams" element={<LiveStreams />} /> */}

        <Route path="/all-members" element={<AllMembers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/sage-chat" element={<SageChat />} />
        <Route path="/user-list" element={<UserList />} />
        <Route path="/tos" element={<Tos />} />
        <Route path="/privacy" element={<Tos />} />
        <Route path="/" element={<ArtistHome />} />
      </Route>
    </Routes>
  );
}

function Layout() {
  return (
    <div className="App">
      <NavbarMenu />

      <div className="background-container">
        <RayCastWaves />

        <div className="content-container">
          <Outlet />

          {/* Other components can go here */}
        </div>
      </div>

      <Footer />
      
    </div>
  );
}

// 3️⃣ Router singleton created
const rx = createBrowserRouter([{ path: "*", element: <Groot /> }]);

// 4️⃣ RouterProvider added
export default function App() {
  return <RouterProvider router={rx} />;
}
